import Vue from 'vue'
import Router from 'vue-router'
import ImageCompress from '../pages/ImageCompress.vue'
import BackgroundRemoval from '../pages/BackgroundRemoval.vue'
import ColorPicker from '../pages/ColorPicker.vue'
import GifConverter from '../pages/GifConverter.vue'
import ImageEditor from '../pages/ImageEditor.vue'
import FormatConverter from '../pages/FormatConverter.vue'
import store from '../store'
import Home from '../pages/Home.vue'
import ColorChanger from '../pages/ColorChanger.vue'
import BookingLossCalculator from '../pages/BookingLossCalculator.vue'
import AppRoiCalculator from '../pages/AppRoiCalculator.vue'
import NotFound from '../pages/NotFound.vue'

const FastImageTool = () => import(/* webpackChunkName: "fast-image-tools" */ '../pages/FastImageTool.vue')
const CompositionImageTool = () => import(/* webpackChunkName: "composition-image-tools" */ '../pages/CompositionImageTool.vue')
const ChartMaker = () => import(/* webpackChunkName: "chart-maker" */ '../pages/ChartMaker.vue')
const FaceBlurTool = () => import(/* webpackChunkName: "face-blur" */ '../pages/FaceBlurTool.vue')
const AdvancedImageTool = () => import(/* webpackChunkName: "advanced-image-tools" */ '../pages/AdvancedImageTool.vue')
const TextTools = () => import(/* webpackChunkName: "text-tools" */ '../pages/TextTools.vue')
const CodeTool = () => import(/* webpackChunkName: "code-tools" */ '../pages/CodeTool.vue')
const SeoMetaTool = () => import(/* webpackChunkName: "seo-tools" */ '../pages/SeoMetaTool.vue')
const SocialMetaTool = () => import(/* webpackChunkName: "seo-social-tools" */ '../pages/SocialMetaTool.vue')
const HeadingChecker = () => import(/* webpackChunkName: "seo-heading-tools" */ '../pages/HeadingChecker.vue')
const ImageMetadataTool = () => import(/* webpackChunkName: "image-metadata-tools" */ '../pages/ImageMetadataTool.vue')
const TechnicalSeoTool = () => import(/* webpackChunkName: "technical-seo-tools" */ '../pages/TechnicalSeoTool.vue')
const SeoFixGuide = () => import(/* webpackChunkName: "seo-guide" */ '../pages/SeoFixGuide.vue')

const encodeArabicRoutePath = route => ({
  ...route,
  path: route.path.startsWith('/ar/') ? encodeURI(route.path) : route.path
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) return { selector: to.hash, offset: { x: 0, y: 16 } }
    return { x: 0, y: 0 }
  },

  routes : [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentLanguage', 'ar');
      next();
    },
  },
  {
    path: '/%D8%AD%D8%A7%D8%B3%D8%A8%D8%A9-%D8%AE%D8%B3%D8%A7%D8%A6%D8%B1-%D8%A7%D9%84%D8%AD%D8%AC%D9%88%D8%B2%D8%A7%D8%AA-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'booking-loss-calculator-ar',
    component: BookingLossCalculator,
    beforeEnter: (to, from, next) => {
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/booking-loss-calculator-from-splendapp',
    name: 'booking-loss-calculator-en',
    component: BookingLossCalculator,
    beforeEnter: (to, from, next) => {
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
  {
    path: '/ar/حاسبة-تأثير-تطبيق-الجوال/',
    name: 'app-roi-calculator-ar',
    component: AppRoiCalculator,
    beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next() },
  },
  {
    path: '/en/app-roi-calculator/',
    name: 'app-roi-calculator-en',
    component: AppRoiCalculator,
    beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next() },
  },
  {
    path: '/%D8%B6%D8%A7%D8%BA%D8%B7-%D8%AD%D8%AC%D9%85-%D8%A7%D9%84%D8%B5%D9%88%D8%B1-%D8%A7%D9%84%D9%85%D8%AC%D8%A7%D9%86%D9%8A-%D8%A3%D9%88%D9%86%D9%84%D8%A7%D9%8A%D9%86-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'image-compress-ar',
    component: ImageCompress,
    beforeEnter: (to, from, next) => {
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/free-image-compressor-from-splendapp',
    name: 'image-compress-en',
    component: ImageCompress,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
  {
    path: '/%D8%A3%D8%AF%D8%A7%D8%A9-%D8%A5%D8%B2%D8%A7%D9%84%D8%A9-%D8%AE%D9%84%D9%81%D9%8A%D8%A9-%D8%A7%D9%84%D8%B5%D9%88%D8%B1%D8%A9-%D8%A3%D9%88%D9%86%D9%84%D8%A7%D9%8A%D9%86-%D9%85%D8%AC%D8%A7%D9%86%D8%A7%D9%8B-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'background-removal-ar',
    component: BackgroundRemoval,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/free-image-editor-from-splendapp',
    name: 'background-removal-en',
    component: BackgroundRemoval,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
  {
    path: '/%D9%85%D8%AD%D8%AF%D8%AF-%D9%84%D9%88%D9%86-%D8%A7%D9%84%D8%B5%D9%88%D8%B1-%D8%A7%D9%84%D9%85%D8%AC%D8%A7%D9%86%D9%8A-%D8%A3%D9%88%D9%86%D9%84%D8%A7%D9%8A%D9%86-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'color-picker-ar',
    component: ColorPicker,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/free-image-color-picker-from-splendapp',
    name: 'color-picker-en',
    component: ColorPicker,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
  {
    path: '/%D8%B5%D8%A7%D9%86%D8%B9-%D8%A7%D9%84%D9%80%20GIF-%D8%A7%D9%84%D9%85%D8%AC%D8%A7%D9%86%D9%8A-%D8%A3%D9%88%D9%86%D9%84%D8%A7%D9%8A%D9%86-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'gif-converter-ar',
    component: GifConverter,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/free-gif-maker-from-splendapp',
    name: 'gif-converter-en',
    component: GifConverter,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },

  {
    path: '/%D9%85%D8%AD%D8%B1%D8%B1-%D9%88%D9%85%D8%B5%D9%85%D9%85-%D8%A7%D9%84%D8%B5%D9%88%D8%B1-%D8%A7%D9%84%D9%85%D8%AC%D8%A7%D9%86%D9%8A-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'image-editor-ar',
    component: ImageEditor,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    path: '/en/image-tools/image-editor/',
    name: 'image-editor-en',
    component: ImageEditor,
    beforeEnter: (to, from, next) => {
        // Set the current language to 'en' in the store
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
  
    {
      path: '/%D9%85%D8%AD%D9%88%D9%84_%D8%AA%D9%86%D8%B3%D9%8A%D9%82%D8%A7%D8%AA_%D9%88%D8%B5%D9%8A%D8%BA_%D8%A7%D9%84%D8%B5%D9%88%D8%B1_%D9%85%D9%86_%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
      name: 'format-converter-ar',
      component: FormatConverter,
      beforeEnter: (to, from, next) => {
          // Set the current language to 'en' in the store
          store.commit('setCurrentLanguage', 'ar');
          next();
      },
    },
    {
      path: '/FreeImageFormatterfromSplendApp',
      name: 'format-converter-en',
      component: FormatConverter,
      beforeEnter: (to, from, next) => {
          // Set the current language to 'en' in the store
          store.commit('setCurrentLanguage', 'en');
          next();
      },
    },
    {
    // الرابط باللغة العربية: /مبدل-الألوان-الذكي-من-سبلينداب
    path: '/%D9%85%D8%A8%D8%AF%D9%84-%D8%A7%D9%84%D8%A3%D9%84%D9%88%D8%A7%D9%86-%D8%A7%D9%84%D8%B0%D9%83%D9%8A-%D9%85%D9%86-%D8%B3%D8%A8%D9%84%D9%8A%D9%86%D8%AF%D8%A7%D8%A8',
    name: 'color-changer-ar',
    component: ColorChanger,
    beforeEnter: (to, from, next) => {
        store.commit('setCurrentLanguage', 'ar');
        next();
    },
  },
  {
    // الرابط باللغة الإنجليزية
    path: '/smart-color-changer-from-splendapp',
    name: 'color-changer-en',
    component: ColorChanger,
    beforeEnter: (to, from, next) => {
        store.commit('setCurrentLanguage', 'en');
        next();
    },
  },
    
    {
      path: '/en/image-tools/flip-image/',
      name: 'flip-image-en',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); },
    },
    {
      path: '/ar/أدوات-الصور/قلب-الصورة/',
      name: 'flip-image-ar',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); },
    },
    {
      path: '/en/image-tools/rotate-image/',
      name: 'rotate-image-en',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); },
    },
    {
      path: '/ar/أدوات-الصور/تدوير-الصورة/',
      name: 'rotate-image-ar',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); },
    },
    {
      path: '/en/image-tools/black-and-white-image/',
      name: 'black-white-image-en',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); },
    },
    {
      path: '/ar/أدوات-الصور/تحويل-الصورة-إلى-أبيض-وأسود/',
      name: 'black-white-image-ar',
      component: FastImageTool,
      beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); },
    },
    { path: '/en/image-tools/pixelate-image/', name: 'pixelate-image-en', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/بكسلة-الصورة/', name: 'pixelate-image-ar', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/round-image/', name: 'round-image-en', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/قص-الصورة-دائرية/', name: 'round-image-ar', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/add-border-to-image/', name: 'border-image-en', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/إضافة-إطار-للصور/', name: 'border-image-ar', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/add-text-to-image/', name: 'text-image-en', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/الكتابة-على-الصور/', name: 'text-image-ar', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/crop-image/', name: 'crop-image-en', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/قص-الصور/', name: 'crop-image-ar', component: FastImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/add-watermark/', name: 'watermark-image-en', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/إضافة-علامة-مائية-على-الصور/', name: 'watermark-image-ar', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/combine-images/', name: 'combine-images-en', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/دمج-الصور/', name: 'combine-images-ar', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/image-splitter/', name: 'image-splitter-en', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/تقسيم-الصور/', name: 'image-splitter-ar', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/collage-maker/', name: 'collage-maker-en', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/تجميع-الصور-في-صورة-واحدة/', name: 'collage-maker-ar', component: CompositionImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/chart-maker/', name: 'chart-maker-en', component: ChartMaker, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/إنشاء-رسم-بياني/', name: 'chart-maker-ar', component: ChartMaker, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/face-blur/', name: 'face-blur-en', component: FaceBlurTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/طمس-الوجوه/', name: 'face-blur-ar', component: FaceBlurTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/background-blur/', name: 'background-blur-en', component: AdvancedImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/تمويه-خلفية-الصورة/', name: 'background-blur-ar', component: AdvancedImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/image-tools/colorize-photo/', name: 'colorize-photo-en', component: AdvancedImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/تلوين-الصور-الأبيض-والأسود/', name: 'colorize-photo-ar', component: AdvancedImageTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/text-tools/case-converter-word-counter/', name: 'text-tools-en', component: TextTools, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-النص/عداد-الكلمات-والحروف/', name: 'text-tools-ar', component: TextTools, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/qr-code-tools/generator/', name: 'qr-generator-en', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-qr/مولد-qr/', name: 'qr-generator-ar', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/qr-code-tools/scanner/', name: 'qr-scanner-en', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-qr/قارئ-qr/', name: 'qr-scanner-ar', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/barcode-tools/generator/', name: 'barcode-generator-en', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الباركود/مولد-باركود/', name: 'barcode-generator-ar', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/barcode-tools/scanner/', name: 'barcode-scanner-en', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الباركود/قارئ-باركود/', name: 'barcode-scanner-ar', component: CodeTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/meta-tag-analyzer-generator/', name: 'seo-meta-tool-en', component: SeoMetaTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/فحص-meta-tags/', name: 'seo-meta-tool-ar', component: SeoMetaTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/open-graph-social-preview/', name: 'social-meta-tool-en', component: SocialMetaTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/معاينة-open-graph/', name: 'social-meta-tool-ar', component: SocialMetaTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/heading-structure-checker/', name: 'heading-checker-en', component: HeadingChecker, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/فحص-h1-h6/', name: 'heading-checker-ar', component: HeadingChecker, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/image-metadata-viewer-editor-remover/', name: 'image-metadata-tool-en', component: ImageMetadataTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-الصور/حذف-بيانات-exif/', name: 'image-metadata-tool-ar', component: ImageMetadataTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/robots-txt-generator-tester/', name: 'robots-tool-en', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/مولد-robots-txt/', name: 'robots-tool-ar', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/sitemap-validator/', name: 'sitemap-validator-en', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/فحص-sitemap-xml/', name: 'sitemap-validator-ar', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/canonical-hreflang-builder/', name: 'canonical-hreflang-en', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/مولد-canonical-hreflang/', name: 'canonical-hreflang-ar', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-tools/schema-markup-generator/', name: 'schema-generator-en', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/أدوات-seo/مولد-schema-markup/', name: 'schema-generator-ar', component: TechnicalSeoTool, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    { path: '/en/seo-guide/how-to-fix-website-seo/', name: 'seo-fix-guide-en', component: SeoFixGuide, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'en'); next(); } },
    { path: '/ar/دليل-seo/تحسين-seo-الموقع/', name: 'seo-fix-guide-ar', component: SeoFixGuide, beforeEnter: (to, from, next) => { store.commit('setCurrentLanguage', 'ar'); next(); } },
    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }



].map(encodeArabicRoutePath)

})

export default router
